module.exports = __webpack_public_path__ + "static/media/header3.22cc6102.jpg";